export const lending_store_open_primary = 'lending_store_open_primary';
export const lending_store_open_page = 'lending_store_open_page';

export function lendingOpenPrimary() {
    return function (dispatch) {
        dispatch({
            type: lending_store_open_primary
        });
    }
}

export function lendingOpenPage(page) {
    return function (dispatch) {
        dispatch({
            type: lending_store_open_page,
            data: page,
        });
    }
}